export default {"src":"/_next/static/media/hero-background.68469e5f.svg","height":462,"width":860,"blurWidth":0,"blurHeight":0};